import { Link, Outlet, useNavigate } from "react-router-dom";

function Dashboard() {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("isLoggedIn");
    navigate("/");
  };

  return (
    <div style={{ display: "flex", height: "100vh" }}>

      {/* SIDEBAR */}
      <div style={styles.sidebar}>
        <h3 style={styles.title}>Student Directory</h3>

        {/* MENU CARDS */}
        <div style={styles.menu}>

          <Link to="search" style={styles.card}>
            🔍 Search
          </Link>

          <Link to="list" style={styles.card}>
            📋 View List
          </Link>

          <Link to="add" style={styles.card}>
            ➕ Add Student
          </Link>

        </div>

        <button onClick={logout} style={styles.logout}>
          Logout
        </button>
      </div>

      {/* PAGE CONTENT */}
      <div style={{ flex: 1, padding: "20px" }}>
        <Outlet />
      </div>

    </div>
  );
}

const styles = {
  sidebar: {
    width: "260px",
    background: "linear-gradient(180deg, #0f172a, #111827)",
    color: "white",
    display: "flex",
    flexDirection: "column",
    padding: "25px",
    height: "100vh",
    boxShadow: "2px 0 10px rgba(0,0,0,0.3)",
  },

  title: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "25px",
    letterSpacing: "1px",
  },

  menu: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },

  card: {
    backgroundColor: "#1f2937",
    color: "#e5e7eb",
    textDecoration: "none",
    padding: "14px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "15px",
    fontWeight: "500",
    transition: "0.2s",
  },

logout: {
  marginTop: "auto",
  padding: "12px",
  backgroundColor: "#1f2937",
  color: "#e5e7eb",
  border: "1px solid #374151",
  borderRadius: "10px",
  cursor: "pointer",
  fontWeight: "500",
  fontSize: "15px",   // ✅ matches sidebar links
  textAlign: "center",  // aligns like menu items
  transition: "0.2s",
},
};

export default Dashboard;